import ms from '../styles/images/ms.png';
import googl from '../styles/images/googl.png';

export default /* @ngInject */ function($routeProvider) {
    $routeProvider.when('/', {
        templateUrl: '/login/login.html',
        controller: 'LoginCtrl',
        controllerAs: 'login',
        title: 'LOG IN',
        ms: ms,
        googl: googl,
        restrictAuthenticated: false
    });

    $routeProvider.when('/login/unverified', {
        templateUrl: '/signup-basic/confirmation/confirmation.html',
        controller: 'SignupBasicConfirmationCtrl',
        controllerAs: 'confirmation',
        title: 'Confirm your email',
        restrictAuthenticated: false
    });

    $routeProvider.when('/login/:verificationStatus', { // account-verified|verification-error
        templateUrl: '/login/login.html',
        controller: 'LoginCtrl',
        controllerAs: 'login',
        title: 'LOG IN',
        ms: ms,
        googl: googl,
        restrictAuthenticated: false
    });
}



// WEBPACK FOOTER //
// ./login/login-routes.js